module.exports = __webpack_public_path__ + "static/media/mainPageMap.9b5b1967.png";